import React from 'react';
import styled from 'styled-components';

const QRWrapper = styled.div`
  background: var(--main-web-color);
  padding: 4px;
  width: 150px;
  border-radius: 4px;

  img {
    width: 100%;
    margin-bottom: 8px;
  }
`;

const WrapperText = styled.div`
  line-height: 25px;
  background-color: var(--main-web-color);
  color: white;
  text-align: center;
`;

export default function BookQRCode({ text, url }) {
  return (
    <QRWrapper>
      <a href={url} target="_blank" rel="noreferrer">
        <img
          src={`https://psczlis.azurewebsites.net/qrcode.ashx?size=10&data=${url}`}
          alt="QR code"
        />
        <WrapperText>{text}</WrapperText>
      </a>
    </QRWrapper>
  );
}
